/**
 * #promoted_telemetry.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../../typeRegistry.js";
function createBaseWebViewPromotedTelemetryEffect() {
    return { eventName: "" };
}
export const WebViewPromotedTelemetryEffect = {
    $type: "devvit.ui.effects.web_view.v1alpha.WebViewPromotedTelemetryEffect",
    encode(message, writer = _m0.Writer.create()) {
        if (message.eventName !== "") {
            writer.uint32(10).string(message.eventName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewPromotedTelemetryEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.eventName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { eventName: isSet(object.eventName) ? globalThis.String(object.eventName) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.eventName !== "") {
            obj.eventName = message.eventName;
        }
        return obj;
    },
    create(base) {
        return WebViewPromotedTelemetryEffect.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWebViewPromotedTelemetryEffect();
        message.eventName = object.eventName ?? "";
        return message;
    },
};
messageTypeRegistry.set(WebViewPromotedTelemetryEffect.$type, WebViewPromotedTelemetryEffect);
function isSet(value) {
    return value !== null && value !== undefined;
}
